import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { customerServiceOrganizationDetailsEntryPoint } from '@jira/spa-apps__customer-service-organization-details/src/customerServiceOrganizationDetailsEntryPoint.entrypoint.tsx';
import { l1CustomersProjectProviderResource } from '@jira/router-resources__customer-service-l1-customers-project-provider/src/l1CustomersProjectProviderResource.tsx';
import { EntitlementsEntitlementsQueryResource } from '@jira/router-resources__service-desk-customer-service-organization-details/src/EntitlementsEntitlementsQueryResource.tsx';
import { OrganizationDetailsPageQueryResource } from '@jira/router-resources__service-desk-customer-service-organization-details/src/OrganizationDetailsPageQueryResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { csmOrganizationDetailsRoute } from '@jira/router-routes__customer-services-customers-routes/src/csmOrganizationDetailsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jsmEmailDomainsListResource } from '@jira/router-resources__get-email-domains-list/src/jsmEmailDomainsListResource.tsx';
import { productsJsmOrganizationDetailsResource } from '@jira/router-resources__organization-details/src/productsJsmOrganizationDetailsResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';

const csmOrganizationDetailsPageEntryPoint = createPageEntryPoint({
	main: customerServiceOrganizationDetailsEntryPoint,
});

export const csmOrganizationDetailsRouteEntry: Route = createEntry(
	csmOrganizationDetailsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.csm-organization-details',
		layout: globalLayout,

		navigation: {
			menuId: MenuIdCustomerExperiences,
			sidebarId: SidebarIdCsmApp,
		},

		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmOrganizationDetailsPageEntryPoint
				: notFoundPageEntrypoint;
		},

		resources: [
			...getCustomerServiceL1NavigationResources(),
			OrganizationDetailsPageQueryResource,
			EntitlementsEntitlementsQueryResource,
			productsJsmOrganizationDetailsResource,
			jsmEmailDomainsListResource,
			l1CustomersProjectProviderResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
